module.exports = __webpack_public_path__ + "img/reference46.513c28a5.jpg";